var _defs, _g, _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgDimFornitori(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Livello_1",
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 75.5 75.5",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("style", null, "\n      .st0 {\n        stroke-linecap: round;\n      }\n\n      .st0, .st1 {\n        fill: none;\n        stroke: #fff;\n        stroke-linejoin: round;\n        stroke-width: 2.9px;\n      }\n    "))), _g || (_g = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M66.1,55.9H21.8c-1.3,0-2.4-.9-2.6-2.2L12.1,3.7c-.2-1.3-1.3-2.2-2.6-2.2H1.5M63.5,68.9c0-2.9-2.3-5.2-5.2-5.2s-5.2,2.3-5.2,5.2,2.3,5.2,5.2,5.2,5.2-2.3,5.2-5.2ZM35.1,68.9c0-2.9-2.3-5.2-5.2-5.2s-5.2,2.3-5.2,5.2,2.3,5.2,5.2,5.2,5.2-2.3,5.2-5.2Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st1",
    d: "M13.5,17.4h16.1M55.8,17.4h18.3l-4.8,25.4c-.2,1.2-1.3,2-2.6,2H17.6"
  }))), _path || (_path = /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M43.1,34.2V6.8M36,26.7l7.1,7.5,7.1-7.5"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgDimFornitori);
export default __webpack_public_path__ + "static/media/dim-fornitori.a6928a102d245e8fc06fc66485333333.svg";
export { ForwardRef as ReactComponent };